import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {UtilService} from './shared/services/util.service';
import {AuthService} from './shared/services/auth.service';
import {Subscription} from 'rxjs/Subscription';
import {MatDialog, MatDialogRef} from '@angular/material';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {SpinnerComponent} from './shared/components/spinner/spinner.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'app';
  showDev: boolean;

  subs = new Subscription();

  spinnerDialogRef: MatDialogRef<SpinnerComponent>;
  shouldShowSpinner$ = new BehaviorSubject(false);

  constructor(
    private readonly utilService: UtilService,
    private readonly authService: AuthService,
    private readonly dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.showDev = this.utilService.isDevelopmentMode;
  }

  ngAfterViewInit() {
    this.subs.add(
      this.utilService.requestsInProgress$.subscribe(requestsInProgress => {
        const shouldShowSpinner = requestsInProgress > 0;
        if (this.shouldShowSpinner$.getValue() !== shouldShowSpinner) {
          this.shouldShowSpinner$.next(shouldShowSpinner);
        }
      })
    );

    this.subs.add(
      this.shouldShowSpinner$.subscribe(shouldShowSpinner => {
        setTimeout(() => {
          if (shouldShowSpinner) {
            this.spinnerDialogRef = this.dialog.open(SpinnerComponent, {
              minHeight: 128,
              minWidth: 128,
              disableClose: true,
              panelClass: 'transparent'
            });
          } else {
            if (!!this.spinnerDialogRef) {
              this.spinnerDialogRef.close();
            }
          }
        });
      })
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts